import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {ComuneModel, IndirizzoModel, LocalitaModel, NazioneModel} from '../../models/estremi-persona-fisica.model';

@Component({
	selector: 'lib-indirizzo-pagamento',
	templateUrl: './indirizzo-pagamento.component.html',
	styleUrls: ['./indirizzo-pagamento.component.scss'],
})
export class IndirizzoPagamentoComponent implements OnInit, OnDestroy {

	@Input()
  ngxsFormPath: string;

	@Input()
	nazioni: NazioneModel[];

	@Input()
	province: LocalitaModel[];

	@Input()
	comuni: ComuneModel[];

	@Input()
	capOptions: string[];

	@Input()
	indirizzo: IndirizzoModel;

	@Input('disableForm')
	set _disableForm(val: boolean) {
	  this.disableForm = val;
	  if (this.disableForm) {
		this.indirizzoForm.disable();
	  } else {
		this.indirizzoForm.enable();
	  }
	}

	disableForm: boolean;

	@Output()
	selectedProvinciaEmitter = new EventEmitter<string>();

	@Output()
	selectedComuneEmitter = new EventEmitter<string>();

	@Output()
	indirizzoEmitter = new EventEmitter<{ indirizzo: IndirizzoModel, isValid: boolean }>();

	indirizzoForm: FormGroup;

	private subscription: Subscription = new Subscription();

	constructor() {
		// this.initIndirizzoForm();
		// this.subscription.add(this.indirizzoForm.controls['isEstero'].valueChanges.subscribe(isEstero => {
		// 	this.indirizzoForm.controls['civico'].setValidators(isEstero ? [] : [Validators.required]);
		// 	this.indirizzoForm.controls['civico'].patchValue(null);
		// 	this.indirizzoForm.controls['civico'].updateValueAndValidity();
		// 	this.indirizzoForm.controls['provincia'].setValidators(isEstero ? [] : [Validators.required]);
		// 	this.indirizzoForm.controls['provincia'].patchValue(null);
		// 	this.indirizzoForm.controls['provincia'].updateValueAndValidity();
		// 	this.indirizzoForm.controls['comune'].setValidators(isEstero ? [] : [Validators.required]);
		// 	this.indirizzoForm.controls['comune'].patchValue(null);
		// 	this.indirizzoForm.controls['comune'].updateValueAndValidity();
		// 	this.indirizzoForm.controls['cap'].setValidators(isEstero ? [] : [Validators.required]);
		// 	this.indirizzoForm.controls['cap'].patchValue(null);
		// 	this.indirizzoForm.controls['cap'].updateValueAndValidity();
		// 	this.indirizzoForm.controls['nazione'].setValidators(isEstero ? [Validators.required] : []);
		// 	this.indirizzoForm.controls['nazione'].patchValue(null);
		// 	this.indirizzoForm.controls['nazione'].updateValueAndValidity();
		// }));
		// this.subscription.add(this.indirizzoForm.controls['provincia'].valueChanges.subscribe(siglaProvincia => this.selectedProvinciaEmitter.emit(siglaProvincia)));
		// this.subscription.add(this.indirizzoForm.controls['comune'].valueChanges.subscribe(codiceCatastale => this.selectedComuneEmitter.emit(codiceCatastale)));
	}

	ngOnInit(): void {
		this.initIndirizzoForm();
		this.setFormControlsValue();
		this.subscription.add(this.indirizzoForm.controls['isEstero'].valueChanges.subscribe(isEstero => {
			this.indirizzoForm.controls['civico'].setValidators(isEstero ? [] : [Validators.required]);
			this.indirizzoForm.controls['civico'].patchValue(null);
			this.indirizzoForm.controls['civico'].updateValueAndValidity();
			this.indirizzoForm.controls['provincia'].setValidators(isEstero ? [] : [Validators.required]);
			this.indirizzoForm.controls['provincia'].patchValue(null);
			this.indirizzoForm.controls['provincia'].updateValueAndValidity();
			this.indirizzoForm.controls['comune'].setValidators(isEstero ? [] : [Validators.required]);
			this.indirizzoForm.controls['comune'].patchValue(null);
			this.indirizzoForm.controls['comune'].updateValueAndValidity();
			this.indirizzoForm.controls['cap'].setValidators(isEstero ? [] : [Validators.required]);
			this.indirizzoForm.controls['cap'].patchValue(null);
			this.indirizzoForm.controls['cap'].updateValueAndValidity();
			this.indirizzoForm.controls['nazione'].setValidators(isEstero ? [Validators.required] : []);
			this.indirizzoForm.controls['nazione'].patchValue(null);
			this.indirizzoForm.controls['nazione'].updateValueAndValidity();
		}));
		this.subscription.add(this.indirizzoForm.controls['provincia'].valueChanges.subscribe(siglaProvincia => this.selectedProvinciaEmitter.emit(siglaProvincia)));
		this.subscription.add(this.indirizzoForm.controls['comune'].valueChanges.subscribe(codiceCatastale => this.selectedComuneEmitter.emit(codiceCatastale)));

		this.indirizzoEmit();
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	initIndirizzoForm(): void {
		this.indirizzoForm = new FormGroup({
			isEstero: new FormControl(null),
			indirizzo: new FormControl(null, [Validators.required]),
			nazione: new FormControl(null),
			civico: new FormControl(null),
			provincia: new FormControl(null),
			comune: new FormControl(null),
			cap: new FormControl(null),
		});
	}

	onProvinciaChange(siglaProvincia: string): void {
		this.indirizzoForm.controls['comune'].patchValue(null);
		this.indirizzoForm.controls['comune'].markAsTouched();
		this.indirizzoForm.controls['cap'].patchValue(null);
		this.indirizzoForm.controls['cap'].markAsTouched();
	}

	onComuneChange(codiceCatastale: string): void {
		this.indirizzoForm.controls['cap'].patchValue(null);
		this.indirizzoForm.controls['cap'].markAsTouched();
	}

	indirizzoEmit(): void {
		this.subscription.add(this.indirizzoForm.valueChanges.pipe(
				debounceTime(500),
				// filter(() => this.indirizzoForm.valid),
			).subscribe((_) => {
				const indirizzo: IndirizzoModel = {
					strada: {
						civico: this.indirizzoForm.controls['civico'].value,
						inidirizzo: this.indirizzoForm.controls['indirizzo'].value,
						tipoToponimo: null
					},
					localita: {
						cap: this.indirizzoForm.controls['cap'].value,
						comune: this.indirizzoForm.controls['comune'].value,
						nazione: this.indirizzoForm.controls['nazione'].value,
						provincia: this.indirizzoForm.controls['provincia'].value
					}

				}
				const isValid = this.indirizzoForm.valid;
				this.indirizzoEmitter.emit({ indirizzo: indirizzo ? indirizzo : null, isValid: isValid });
			})
		);
	}

	setFormControlsValue(): void{
		this.indirizzoForm.controls['isEstero'].setValue(this.indirizzo && this.indirizzo?.localita?.comune.startsWith("Z") ?  true : false);
		this.indirizzoForm.controls['indirizzo'].setValue(this.indirizzo ? this.indirizzo.strada.inidirizzo : null);
		this.indirizzoForm.controls['nazione'].setValue(this.indirizzo ? this.indirizzo?.localita?.nazione : null);
		this.indirizzoForm.controls['civico'].setValue(this.indirizzo ? this.indirizzo.strada.civico : null);
		this.indirizzoForm.controls['provincia'].setValue(this.indirizzo && !this.indirizzo?.localita?.comune.startsWith("Z") ? this.indirizzo.localita.provincia : null);
		this.indirizzoForm.controls['comune'].setValue(this.indirizzo && !this.indirizzo?.localita?.comune.startsWith("Z") ? this.indirizzo.localita.comune : null);
		this.indirizzoForm.controls['cap'].setValue(this.indirizzo && !this.indirizzo?.localita?.comune.startsWith("Z") ? this.indirizzo.localita.cap : null);
	}
}
